var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6078_2975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 4.25,
    width: 6.5,
    height: 15.5,
    rx: 1.75,
    stroke: "#2B323B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 4.25,
    width: 6.5,
    height: 15.5,
    rx: 1.75,
    stroke: "#2B323B",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6078_2975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListHorizontal);
export default __webpack_public_path__ + "static/media/List-horizontal.d7906d568fcd93f90881489b14ca766a.svg";
export { ForwardRef as ReactComponent };